import { render } from "./pengajuan.vue?vue&type=template&id=40f2f042&scoped=true"
import script from "./pengajuan.vue?vue&type=script&lang=js"
export * from "./pengajuan.vue?vue&type=script&lang=js"

import "./pengajuan.vue?vue&type=style&index=0&id=40f2f042&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40f2f042"

export default script